module.exports = "https://web-assets.ifttt.com/packs/media/partners/edit-04191167.svg";